import { render, staticRenderFns } from "./CancelChanges.vue?vue&type=template&id=0d6c80da&"
import script from "./CancelChanges.vue?vue&type=script&lang=js&"
export * from "./CancelChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports